import { PageIntro } from '../components/PageIntro';
import { Seo } from '../components/Seo';

const donationUrl = import.meta.env.VITE_STRIPE_DONATION_URL ?? '#';

const programs = [
  {
    title: 'Critical Repairs',
    description: 'Urgent work that helps resolve health and safety hazards, such as roof leaks, unsafe electrical systems, plumbing failures, and structural concerns.',
  },
  {
    title: 'Safe & Accessible Homes',
    description: 'Practical modifications that help children, adults, and older family members move through their homes more safely and independently.',
  },
  {
    title: 'Weather-Ready Homes',
    description: 'Repairs and weatherization improvements that help protect homes from the elements, improve comfort, and reduce wasted energy.',
  },
];

export function ProjectsPage() {
  return (
    <>
      <Seo title="Our work" description="Explore our nonprofit programs, services, and projects." />
      <PageIntro eyebrow="Our work" title="Repairs chosen for real household needs.">
        <p>We focus on repairs that reduce hazards, preserve affordable housing, and give families greater peace of mind.</p>
      </PageIntro>
      <section className="section">
        <div className="container project-list">
          {programs.map((program, index) => (
            <article className="project-row" key={program.title}>
              <div className="project-index">0{index + 1}</div>
              <div>
                <h2>{program.title}</h2>
                <p>{program.description}</p>
                <p className="placeholder-note">Availability and eligibility depend on funding, location, household income, and project scope.</p>
              </div>
            </article>
          ))}
        </div>
      </section>
      <section className="section callout">
        <div className="container callout-inner">
          <h2>Help fund critical home repairs.</h2>
          <a className="button button-light" href={donationUrl}>Donate</a>
        </div>
      </section>
    </>
  );
}
